import { render, staticRenderFns } from "./bandLoginPaw.vue?vue&type=template&id=130ce28d&scoped=true"
import script from "./bandLoginPaw.vue?vue&type=script&lang=js"
export * from "./bandLoginPaw.vue?vue&type=script&lang=js"
import style0 from "./bandLoginPaw.vue?vue&type=style&index=0&id=130ce28d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ce28d",
  null
  
)

export default component.exports